import React from "react";

import "../styles/Intro.css";
import Typist from "react-typist";
import "react-typist/dist/Typist.css";
import GaziModel from "./GaziModel";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import FadeInSection from "./FadeInSection";
import Emoji from "./Emoji"

class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
      <div id="intro">
        <Typist avgTypingDelay={120}>
          <span className="intro-title"> 
            {"hello, "} 
            <Emoji symbol="👋🏽 "/>
            <span className="intro-name">{"Shivani"}</span>
            {" here"}
          </span>
        </Typist>
        <FadeInSection>
          <div className="intro-subtitle">welcome to my tiny corner of the internet <Emoji symbol="🔮"/> 
          </div>
          <div className="intro-desc">
            I'm a data scientist passionate about the applications of machine learning and human-computer interactions.</div>
          <a
            href="mailto:shivani.adusumilli@gmail.com"
            className="intro-contact"
          >
            <EmailRoundedIcon></EmailRoundedIcon>
            {"  " + "Say hello"}
          </a>
        </FadeInSection>
      </div>
    );
  }
}

export default Intro;
